/* Bundle gifts — collapse free-gift line items into one nested strip.
   Gifts remain real line items; this only changes how the drawer renders them. */
(function () {
  'use strict';

  var GIFT_FLAG = '.cartitem-free-product-label';
  var STRIP_CLASS = 'cart-item--bundle-gifts';
  var CHEVRON =
    '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2.75" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var building = false;
  var observer = null;

  function parseMoney(text) {
    if (!text) return null;
    var raw = text.replace(/\s|&nbsp;/g, '');
    var symMatch = raw.match(/[^\d.,\-]+/);
    var sym = symMatch ? symMatch[0] : '';
    var num = raw.replace(/[^\d.,]/g, '');
    if (!num) return null;
    var frac = 0;
    var whole = num;
    var tail = num.match(/[.,](\d{1,2})$/);
    if (tail) {
      frac = parseInt((tail[1] + '0').slice(0, 2), 10);
      whole = num.slice(0, num.length - tail[0].length);
    }
    whole = parseInt(whole.replace(/[.,]/g, ''), 10);
    if (isNaN(whole)) return null;
    return { sym: sym, cents: whole * 100 + frac };
  }

  function formatMoney(sym, cents) {
    var value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return sym + value;
  }

  // The main device is not necessarily first in cart order, so anchor the strip
  // to the highest-value paid line rather than to whatever happens to be on top.
  function rowPrice(row) {
    var el = row.querySelector(".cart-item__final-price");
    var txt = el ? el.textContent : (row.querySelector(".gb-price-drawer") || {}).textContent;
    var parts = String(txt || "").trim().split(/\s+/);
    var m = parseMoney(parts[parts.length - 1]);
    return m ? m.cents : -1;
  }

  function pickAnchor(paid) {
    var best = null;
    var bestCents = -1;
    paid.forEach(function (row) {
      var c = rowPrice(row);
      if (c > bestCents) { bestCents = c; best = row; }
    });
    return best || paid[0] || null;
  }

  function readGift(row) {
    var img = row.querySelector('.cart-item__image');
    var name = row.querySelector('.cart-item__name');
    var was = row.querySelector('.cart-item__old-price');
    return {
      src: img ? img.getAttribute('src') : '',
      title: name ? name.textContent.trim() : '',
      was: was ? was.textContent.trim() : ''
    };
  }

  function buildStrip(gifts, colSpan) {
    var totalCents = 0;
    var sym = null;
    var parseable = true;

    gifts.forEach(function (g) {
      var m = parseMoney(g.was);
      if (!m || (sym !== null && m.sym !== sym)) {
        parseable = false;
        return;
      }
      sym = m.sym;
      totalCents += m.cents;
    });

    var tr = document.createElement('tr');
    tr.className = 'cart-item ' + STRIP_CLASS;
    tr.setAttribute('role', 'row');

    var td = document.createElement('td');
    td.colSpan = colSpan;

    var details = document.createElement('details');
    details.className = 'cart-gifts';

    var summary = document.createElement('summary');
    summary.className = 'cart-gifts__summary';

    var thumbs = document.createElement('span');
    thumbs.className = 'cart-gifts__thumbs';
    gifts.forEach(function (g) {
      if (!g.src) return;
      var im = document.createElement('img');
      im.src = g.src;
      im.alt = '';
      im.loading = 'lazy';
      im.width = 30;
      im.height = 30;
      thumbs.appendChild(im);
    });

    var label = document.createElement('span');
    label.className = 'cart-gifts__label';
    label.appendChild(
      document.createTextNode(
        gifts.length + (gifts.length === 1 ? ' free gift included' : ' free gifts included')
      )
    );
    if (parseable && totalCents > 0) {
      var s = document.createElement('s');
      s.textContent = formatMoney(sym, totalCents);
      label.appendChild(s);
    }

    var chev = document.createElement('span');
    chev.className = 'cart-gifts__chev';
    chev.innerHTML = CHEVRON;

    summary.appendChild(thumbs);
    summary.appendChild(label);
    summary.appendChild(chev);

    var ul = document.createElement('ul');
    ul.className = 'cart-gifts__list';
    gifts.forEach(function (g) {
      var li = document.createElement('li');
      if (g.src) {
        var im = document.createElement('img');
        im.src = g.src;
        im.alt = '';
        im.loading = 'lazy';
        li.appendChild(im);
      }
      var nm = document.createElement('span');
      nm.className = 'cart-gifts__name';
      nm.textContent = g.title;
      li.appendChild(nm);

      var free = document.createElement('em');
      free.className = 'cart-gifts__free';
      if (g.was) {
        var ws = document.createElement('s');
        ws.textContent = g.was;
        free.appendChild(ws);
      }
      free.appendChild(document.createTextNode('FREE'));
      li.appendChild(free);

      ul.appendChild(li);
    });

    details.appendChild(summary);
    details.appendChild(ul);
    td.appendChild(details);
    tr.appendChild(td);
    return tr;
  }

  function render(drawer) {
    var table = drawer.querySelector('.cart-items');
    if (!table) {
      drawer.classList.remove('bundle-gifts-ready');
      return;
    }

    var old = table.querySelector('tr.' + STRIP_CLASS);
    if (old) old.parentNode.removeChild(old);

    var rows = Array.prototype.slice.call(table.querySelectorAll('tr.cart-item'));
    var gifts = [];
    var paid = [];

    rows.forEach(function (row) {
      if (row.classList.contains(STRIP_CLASS)) return;
      // Skip rows the theme hides on purpose (e.g. shipping protection).
      if (row.style.display === 'none') return;

      if (row.querySelector(GIFT_FLAG)) {
        row.classList.add('js-bundle-gift');
        gifts.push(row);
      } else {
        row.classList.remove('js-bundle-gift');
        paid.push(row);
      }
    });

    if (!gifts.length) {
      drawer.classList.remove('bundle-gifts-ready');
      return;
    }

    drawer.classList.add('bundle-gifts-ready');

    var anchor = pickAnchor(paid);

    var colSpan = anchor ? anchor.children.length : gifts[0].children.length;
    var strip = buildStrip(gifts.map(readGift), colSpan || 2);

    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(strip, anchor.nextSibling);
    } else {
      // Cart contains only gifts — put the strip at the top.
      gifts[0].parentNode.insertBefore(strip, gifts[0]);
    }
  }

  function refresh() {
    if (building) return;
    building = true;
    if (observer) observer.disconnect();
    try {
      var drawers = document.querySelectorAll('.cart-drawer');
      for (var i = 0; i < drawers.length; i++) render(drawers[i]);
    } catch (e) {
      if (window.console) console.warn('[bundle-gifts]', e);
    }
    if (observer) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
    building = false;
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      refresh();
    });
  }

  function start() {
    refresh();
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('cart:updated', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.__bundleGiftsRefresh = refresh;
})();
